import { render, staticRenderFns } from "./NavigationMenuPage.vue?vue&type=template&id=41673918&scoped=true&"
import script from "./NavigationMenuPage.vue?vue&type=script&lang=js&"
export * from "./NavigationMenuPage.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMenuPage.vue?vue&type=style&index=0&id=41673918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41673918",
  null
  
)

export default component.exports